import { render } from "./MainTurns.vue?vue&type=template&id=19f1602c&scoped=true"
import script from "./MainTurns.vue?vue&type=script&lang=js"
export * from "./MainTurns.vue?vue&type=script&lang=js"

import "./MainTurns.vue?vue&type=style&index=0&id=19f1602c&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f1602c"]])

export default __exports__